import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot } from "@angular/router";
import { AuthService } from "../auth.service";

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  
  constructor(private _auth: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const onlyExecutive: boolean = route.data?.onlyExecutive;
    const expectedRoles: number[] = route.data?.expectedRoles;
    
    if (onlyExecutive && !this._auth.user.isExecutive()) {
      this._auth.logout();
      return false;
    }
    
    const result = this._auth.user
    .getUserData()
    .roles.filter((role) => expectedRoles.indexOf(role.id) > -1);
    
    if (result.length > 0) {
      return true;
    } else {
      this._auth.logout();
      return false;
    }
  }
}
